import React from "react";

function FooterDashBoard() {
  return (
    <div>
      <div className="container copyright text-center mt-4">
        <p>
          © <span>2026</span>{" "}
          <strong className="px-1 sitename">BR Infotainment</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
        <div className="credits">
          Designed by <a href="https://brainrock.in/">Brainrock</a>
        </div>
      </div>
    </div>
  );
}

export default FooterDashBoard;
